import { Swiper, SwiperSlide } from "swiper/react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePostsSlider } from '../../hooks/usePost';

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import './Slider.css'
import sanityClient from '../../client'
import imageUrlBuilder from '@sanity/image-url'


// import Swiper core and required modules
import SwiperCore, {
    Pagination
  } from 'swiper';
  
// install Swiper modules
SwiperCore.use([Pagination]);

const  builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
    return builder.image(source)
}

function Slider() {
    const { images } = usePostsSlider();
    const { i18n } = useTranslation();
    return (
        <>
            <Swiper 
                slidesPerView={'auto'} 
                centeredSlidesBounds = {true}
                freeMode={true}
                initialSlide = {1}
                spaceBetween={0} 
                pagination={{
                    "clickable": true
                }} 
                className="mySwiper"    
            >
                {images &&
                    images.map((item, i) => (
                        <SwiperSlide key={i}>
                            <NavLink to={"/post/" + item._id + '?index=' + i} >
                                <img src={urlFor(item.slider.image_slider).url()} alt="img1" />
                                {i18n.language === "es"  ?
                                    <p className="img-text">{item.title.es}</p>
                                    :
                                    <p className="img-text">{item.title.en}</p>
                                }
                                
                            </NavLink>
                        </SwiperSlide>
                    ))
                    
                }
            </Swiper>
        </>
    )
}

export default Slider
